<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-1">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="5" label="Name" label-align="right" :state="stateForField('name')" :invalid-feedback="errorForField('name')">
              <b-form-input v-model="bundle.name"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="5" label="Provider Description" label-align="right" :state="stateForField('providerDescription')" :invalid-feedback="errorForField('providerDescription')">
              <b-form-textarea v-model="bundle.description"></b-form-textarea>
            </b-form-group>
            <b-form-group :label-cols="5" label="Patient Description" label-align="right" :state="stateForField('patientDescription')" :invalid-feedback="errorForField('patientDescription')">
              <b-form-textarea v-model="bundle.patientDescription"></b-form-textarea>
            </b-form-group>
            <b-form-group  horizontal
                          :label-cols="5"
                          breakpoint="md"
                          :state="stateForField('location')"
                          :invalid-feedback="errorForField('location')"
                          label="Location:"
                          label-class="text-right">
              <b-form-radio-group v-model="hasMultipleLocations" class="pt-2" :options="selectedLocationOptions"/>
            </b-form-group>
            <b-form-group  v-if="hasMultipleLocations === true"
                           horizontal
                           :label-cols="5"
                           breakpoint="md"
                           :state="stateForField('multipleLocationSelect')"
                           :invalid-feedback="errorForField('multipleLocationSelect')"
                           label="Selected Locations"
                           label-class="text-right">
              <b-dropdown
                  ref="locationDropdown"
                  menu-class="dropdown-container"
                  id="locationField"
                  :text="locationSelectName"
                  :variant="hasError('location') ? 'outline-danger' : 'outline-dark'">
                <b-form-checkbox
                    v-for="location in locations" :key="location.locationId"
                    :id="'location-' + location.locationId"
                    v-model="selectedLocationIds"
                    :value="location.locationId"
                    class="checkbox-class"
                    stacked
                >{{ location.name }}
                </b-form-checkbox>
                <hr class="checkbox-button-line">
                <button type="button" class="btn btn-orange mr-2 float-right" @click="applyLocationSelection">Apply</button>
              </b-dropdown>
            </b-form-group>
            <b-form-group horizontal
                          :label-cols="5"
                          breakpoint="md"
                          :state="stateForField('durationDays')"
                          :invalid-feedback="errorForField('durationDays')"
                          label="Episode Term:"
                          label-class="text-right"
                          :disabled="bundle.status === 'Published'">
              <b-form-radio-group v-model="isMultiDay" class="pt-2" :options="bundleDurationOptions"/>
            </b-form-group>
            <b-form-group :disabled="bundle.status === 'Published'" v-if="isMultiDay" :label-cols="5" label="Days in Episode" label-align="right" :state="stateForField('durationDayAmount')" :invalid-feedback="errorForField('durationDayAmount')">
              <b-form-input v-model="bundle.durationDays"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="5"
                          breakpoint="md"
                          :state="stateForField('selectedImplantOption')"
                          :invalid-feedback="errorForField('selectedImplantOption')"
                          label="Implant Included?"
                          label-class="text-right"
                          >
              <b-form-radio-group :disabled="bundle.status === 'Published'" stacked v-model="selectedImplantOption" class="pt-2" :options="implantOptions"></b-form-radio-group>
            </b-form-group>
            <b-form-group v-if="selectedImplantOption === 'lineItem'" horizontal
                          :label-cols="5"
                          breakpoint="md"
                          :state="stateForField('implantRequired')"
                          :invalid-feedback="errorForField('implantRequired')"
                          label="Implant Required?"
                          label-class="text-right">
              <b-form-radio-group :disabled="bundle.status === 'Published'" v-model="bundle.implantRequired" class="pt-2" :options="yesNoOptions"/>
            </b-form-group>
            <b-form-group v-if="employerId > 0" horizontal
                          :label-cols="5"
                          breakpoint="md"
                          :state="stateForField('ApprovalRequired')"
                          :invalid-feedback="errorForField('ApprovalRequired')"
                          label="Approval Required?"
                          label-class="text-right">
              <b-form-radio-group v-model="approvalRequired" class="pt-2" :options="yesNoOptions"/>
            </b-form-group>
            <b-form-group :disabled="bundle.status === 'Published'" :label-cols="5" label="Amount" label-align="right" :state="stateForField('amount')" :invalid-feedback="errorForField('amount')">
              <b-input-group prepend="$"><b-form-input v-model="bundle.amount"></b-form-input></b-input-group>
            </b-form-group>
            <b-form-group :label-cols="5"
                          breakpoint="md"
                          :state="stateForField('patientAmountRequired')"
                          :invalid-feedback="errorForField('patientAmountRequired')"
                          label="Patient Cost Required?"
                          label-class="text-right"
                          :disabled="bundle.status === 'Published'">
              <b-form-radio-group stacked v-model="selectedPatientPaymentType" class="pt-2" :options="patientAmountOptions"/>
            </b-form-group>
            <b-form-group v-if="selectedPatientPaymentType === 'FixedAmount'" :disabled="bundle.status === 'Published'" :label-cols="5" label="Patient Cost Amount" label-align="right" :state="stateForField('patientAmount')" :invalid-feedback="errorForField('patientAmount')">
              <b-input-group prepend="$"><b-form-input v-model="bundle.patientAmount"></b-form-input></b-input-group>
            </b-form-group>
            <b-form-group :disabled="bundle.status === 'Published'" :label-cols="5" label="Lead Code" label-align="right" :state="stateForField('code')" :invalid-feedback="errorForField('code')">
              <b-form-input v-model="bundle.code"></b-form-input>
            </b-form-group>
            <b-form-group :disabled="bundle.status === 'Published'" :label-cols="5" label="Lead Code Modifier" label-align="right" :state="stateForField('modifier')" :invalid-feedback="errorForField('modifier')">
              <b-form-input v-model="bundle.modifier"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-8">
            <div class="row">
              <div class="col-5 px-0 text-right">Included Codes</div>
              <div class="col px-2">
                <div v-for="code in bundle.codes" :key="code.organizationBundleCodeId" class="current-code mb-1">
                  {{ displayCode(code) }}
                  <font-awesome-icon v-if="bundle.status !== 'Published'" @click="removeCode(code)" class="mx-1" :icon="['far', 'trash-alt']"/>
                </div>
                <div v-if="!bundle.codes || bundle.codes.length === 0">
                  No codes added.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-8">
            <div class="row">
              <div class="col-5 px-0 pt-3 text-right col-form-label">Add Code</div>
              <div class="col p-2">
                <div v-if="bundle.status !== 'Published'">
                <autocomplete :orange-border="false" :options="matchedCodes" v-model="searchTerm" @select="selectCode" placeholder="Add code...">
                  <template slot-scope="{ option }">
                    <div class="content">
                      <p>{{ option.code }}<span v-if="option.modifier">&nbsp; {{ option.modifier }}</span><br>
                        {{ option.description }}</p>
                    </div>
                  </template>
                </autocomplete>
                </div>
                <div v-if="bundle.status === 'Published'">
                  <b-form-input :disabled="bundle.status === 'Published'">
                    <autocomplete :orange-border="false" :options="matchedCodes" v-model="searchTerm" @select="selectCode" placeholder="Add code...">
                      <template slot-scope="{ option }">
                        <div class="content">
                          <p>{{ option.code }}<span v-if="option.modifier">&nbsp; {{ option.modifier }}</span><br>
                            {{ option.description }}</p>
                        </div>
                      </template>
                    </autocomplete>
                  </b-form-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  import _ from 'lodash'
  import Autocomplete from '@/components/Autocomplete'

  export default {
    name: 'BundleModal',

    mixins: [ErrorsMixin],

    components: { Autocomplete },

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      editBundle: {
        type: Object,
        required: false
      },

      bundleType: {
        type: String,
        required: true
      },

      employerId: {
        type: Number,
        required: false
      },

      employer: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        bundle: {
          durationDays: 0,
          patientPaymentType: 0,
          locations: []
        },
        isSaving: false,
        searchTerm: '',
        matchedCodes: [],
        bundleTypeOptions: [
          { value: 'SelfPay', text: 'Self Pay' },
          { value: 'Employer', text: 'Employer / TPA' }
        ],
        implantOptions: [
          { value: 'none', text: 'No Implant' },
          { value: 'included', text: 'Included in Episode Fee' },
          { value: 'lineItem', text: 'Add as Line Item Fee' }
        ],
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ],
        selectedLocationOptions: [
          { value: false, text: 'All Locations' },
          { value: true, text: 'Choose Specific Locations' }
        ],
        bundleDurationOptions: [
          { value: true, text: 'Multiday' },
          { value: false, text: 'Date of Service' }
        ],
        patientAmountOptions: [
          { value: 'None', text: 'No Cost' },
          { value: 'FixedAmount', text: 'Fixed Amount' },
          { value: 'MaxOOP', text: 'Max OOP' }
        ],
        employers: [],
        employerOptions: [],
        selectedEmployerOptions: [],
        selectedImplantOption: '',
        selectedPatientPaymentType: '',
        isMultiDay: null,
        approvalRequired: true,
        hasMultipleLocations: false,
        locationSelectName: 'Select Locations',
        selectedLocationIds: []
      }
    },

    watch: {
      editBundle (newValue) {
        this.clearAllErrors()
        this.bundle = _.clone(newValue)
        if (this.bundle.organizationBundleId > 0) {
          this.isMultiDay = this.bundle.durationDays > 0
          this.approvalRequired = this.bundle.approvalRequired
        } else {
          this.isMultiDay = null
          this.approvalRequired = true
          this.selectedPatientPaymentType = 'None'
          this.selectedImplantOption = 'none'
          this.selectedLocationIds = []
          this.locationSelectName = 'Select Locations'
          this.hasMultipleLocations = false
        }
        this.selectedEmployerOptions = []
        if (newValue.mappings && newValue.mappings.length > 0) {
          for (const mapping of newValue.mappings) {
            this.selectedEmployerOptions.push(mapping.organizationEmployerId)
          }
        }
        if (this.bundle.bundleHasImplant === true && this.bundle.implantCostIncluded === false) {
          this.selectedImplantOption = 'lineItem'
        } else if (this.bundle.implantCostIncluded === true && this.bundle.implantRequired === false && this.bundle.implantRequired === false) {
          this.selectedImplantOption = 'included'
        } else if (this.bundle.bundleHasImplant === false && this.bundle.implantCostIncluded === false && this.bundle.implantRequired === false) {
          this.selectedImplantOption = 'none'
        }

        if (this.bundle.patientPaymentType === 'FixedAmount' || this.bundle.patientAmount > 0) {
          this.selectedPatientPaymentType = 'FixedAmount'
        } else if (this.bundle.patientPaymentType === 'MaxOOP') {
          this.selectedPatientPaymentType = 'MaxOOP'
        } else if (this.bundle.patientPaymentType === 'None') {
          this.selectedPatientPaymentType = 'None'
        }
        if (this.bundle.locations && this.bundle.locations.length > 0) {
          this.selectedLocationIds = this.bundle.locations.map(loc => loc.locationId || loc.locationId) || []
          this.locationSelectName = this.bundle.locations
          const selectedNames = this.bundle.locations
            .filter(location => this.selectedLocationIds.includes(location.locationId))
            .map(location => location.name)
          if (selectedNames.length > 0) {
            this.locationSelectName = selectedNames.length > 3
              ? `${selectedNames.length} locations selected`
              : selectedNames.join(', ')
          }
        } else {
          this.locationSelectName = 'Select Locations'
          this.selectedLocationIds = []
        }
        this.hasMultipleLocations = this.selectedLocationOptions === true || this.bundle.locations.length > 0
      },

      searchTerm: _.debounce(function (searchTerm) {
        this.searchCodes()
      }, 500)
    },

    computed: {
      title () {
        if (this.bundle && this.bundle.organizationBundleId && this.bundleType === 'SelfPay') {
          return 'Edit Self Pay Episode'
        } else if (this.bundle && this.bundle.organizationBundleId && this.bundleType === 'Employer' && this.employer) {
          return 'Edit ' + this.employer.name + ' Episode'
        } else if (this.bundle && this.bundleType === 'SelfPay') {
          return 'Create Self Pay Episode'
        } else if (this.bundle && this.bundleType === 'Employer' && this.employer) {
          return 'Create ' + this.employer.name + ' Episode'
        }
        return ''
      },
      locations () {
        return this.$store.organization.locations
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()
        if (!this.bundle.name) {
          this.addErrorForField('name', 'You must add an episode name.')
        }
        if (!this.bundle.amount) {
          this.addErrorForField('amount', 'You must add an amount.')
        }
        if (!this.bundle.code) {
          this.addErrorForField('code', 'You must add a lead code.')
        }
        if (this.isMultiDay !== true && this.isMultiDay !== false) {
          this.addErrorForField('durationDays', 'You select an episode term.')
        }
        if (this.isMultiDay === true && !this.bundle.durationDays) {
          this.addErrorForField('durationDayAmount', 'You enter a day amount.')
        }
        return !this.hasErrors()
      },

      displayCode (code) {
        let codeDisplay = code.code
        if (code.modifier) {
          codeDisplay = codeDisplay + ' ' + code.modifier
        }

        if (code.description) {
          codeDisplay = codeDisplay + ' - ' + code.description
        }

        return codeDisplay
      },

      save () {
        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.clearAllErrors()

        let urlSuffix = ''
        if (this.bundle.organizationBundleId) {
          urlSuffix = '/' + this.bundle.organizationBundleId
        }

        if (!this.isMultiDay) {
          this.bundle.durationDays = 0
        }

        if (this.bundleType === 'SelfPay') {
          this.bundle.bundleType = 'SelfPay'
          this.bundle.approvalRequired = false
        } else {
          this.bundle.bundleType = 'Employer'
          this.bundle.organizationEmployerId = this.employerId
          this.bundle.approvalRequired = this.approvalRequired
        }
        if (this.selectedImplantOption === 'lineItem') {
          this.bundle.bundleHasImplant = true
          this.bundle.implantCostIncluded = false
        } else if (this.selectedImplantOption === 'included') {
          this.bundle.bundleHasImplant = true
          this.bundle.implantCostIncluded = true
          this.bundle.implantRequired = false
        } else if (this.selectedImplantOption === 'none') {
          this.bundle.bundleHasImplant = false
          this.bundle.implantCostIncluded = false
          this.bundle.implantRequired = false
        }
        if (this.selectedPatientPaymentType === 'FixedAmount' && this.bundle.patientAmount > 0) {
          this.bundle.patientPaymentType = 'FixedAmount'
        } else if (this.selectedPatientPaymentType === 'MaxOOP') {
          this.bundle.patientPaymentType = 'MaxOOP'
        } else if (this.selectedPatientPaymentType === 'None') {
          this.bundle.patientPaymentType = 'None'
        }
        if (this.hasMultipleLocations === true && this.selectedLocationIds && this.selectedLocationIds.length > 0) {
          this.bundle.locations = this.selectedLocationIds.map(id => ({ locationId: id }))
        } else if (this.hasMultipleLocations === false) {
          this.bundle.locations = []
        }
        this.isSaving = true
        api.post('/Dashboard/Bundle' + urlSuffix, this.bundle).then(response => {
          this.$emit('bundleSaved', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to save bundle: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      },

      loadEmployers () {
        api.get('/Dashboard/Employers').then(response => {
          this.employers = response.data
          this.employerOptions = []
          for (const employer of this.employers) {
            this.employerOptions.push({
              value: employer.organizationEmployerId,
              text: employer.name
            })
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load employers: ' + error.message, error)
          }
        })
      },

      searchCodes () {
        if (!this.searchTerm) {
          this.matchedCodes = []
          return
        }

        const parameters = {
          searchTerm: this.searchTerm
        }

        api.post('/Dashboard/CodeSearch', parameters).then(response => {

          this.matchedCodes = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to search for code: ' + error.message, error)
          }
        })
      },

      selectCode (code) {
        this.searchTerm = ''
        if (!this.bundle.codes) {
          this.bundle.codes = []
        }
        this.bundle.codes.push({
          code: code.code,
          description: code.description,
          modifier: code.modifier ? code.modifier : null
        })
      },

      removeCode (code) {
        this.bundle.codes = this.bundle.codes.filter((aCode) => {
          return !(aCode.code === code.code && aCode.modifier === code.modifier)
        })
      },
      applyLocationSelection () {
        this.$refs.locationDropdown.hide()
        const selectedNames = this.locations
          .filter(location => this.selectedLocationIds.includes(location.locationId))
          .map(location => location.name)

        if (selectedNames.length > 0) {
          this.locationSelectName = selectedNames.length > 3
            ? `${selectedNames.length} locations selected`
            : selectedNames.join(', ')
        } else {
          this.locationSelectName = 'Select Locations'
        }
      }
    },

    created () {
      this.loadEmployers()
    }
  }
</script>

<style scoped>
.current-code .fa-trash-alt {
  cursor: pointer;
}

.current-code .fa-trash-alt:HOVER {
  color: rgb(255, 70, 0);
}
/deep/ #locationField .dropdown-toggle {
  max-width: 276px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#locationId {
  max-width: 300px;
  text-overflow: ellipsis;
}
.dropdown-class /deep/ .dropdown-menu {
  max-height: 200px;
  max-width: 400px;
  overflow-y: auto;
}
.checkbox-class {
  width: 276px;
  margin-left: 10px;
}
.checkbox-button-line {
  margin: 10px 0;
}
</style>
